module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '-access-scheme')))]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.details')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('access-form', {
    attrs: {
      "access": _vm.accessScheme,
      "additional-fields": {
        'name': {
          type: 'text'
        }
      },
      "buttons": [{
        title: 'submit',
        action: _vm.submit
      }, {
        title: 'cancel',
        action: _vm.cancel
      }]
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.accessScheme.new) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('tab.groups')
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-groups')))]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.filterSwitchGroups,
      "placeholder": _vm.$t('placeholder.switch_group')
    },
    on: {
      "change": _vm.switchGroupSelected
    },
    model: {
      value: (_vm.selectedSwitchGroupId),
      callback: function($$v) {
        _vm.selectedSwitchGroupId = $$v
      },
      expression: "selectedSwitchGroupId"
    }
  }, _vm._l((_vm.filterSwitchGroups()), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(item.label),
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.filterMobileGroups,
      "placeholder": _vm.$t('placeholder.mobile_group')
    },
    on: {
      "change": _vm.mobileGroupSelected
    },
    model: {
      value: (_vm.selectedMobileGroupId),
      callback: function($$v) {
        _vm.selectedMobileGroupId = $$v
      },
      expression: "selectedMobileGroupId"
    }
  }, _vm._l((_vm.filterMobileGroups()), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(item.label),
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitGroups
    }
  }, [_vm._v(_vm._s(_vm.$t('button.add-new')))])], 1), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": _vm.groups,
      "columns": ['switchGroupName', 'mobileGroupName'],
      "showSearch": false,
      "operations": [{
        label: 'delete',
        permission: 'DELETE_MOBILE_ACCESS_GROUP',
        type: 'danger',
        icon: 'delete',
        method: _vm.deleteMobileAccessGroup
      }]
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91f6a3ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access-scheme/AccessSchemeDetails.vue
// module id = 1019
// module chunks = 2